import { render, staticRenderFns } from "./ReportComment.vue?vue&type=template&id=0ca9f993&"
import script from "./ReportComment.vue?vue&type=script&lang=js&"
export * from "./ReportComment.vue?vue&type=script&lang=js&"
import style0 from "./ReportComment.vue?vue&type=style&index=0&media=screen&lang=css&"
import style1 from "./ReportComment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports